export default __webpack_public_path__ + "static/confetti-fe9858fd3ddf6551d6306329327c6728.jpg";